import type { CSSProperties } from 'react';
import { LinkList } from './LinkList';
import type { LinkListsProps } from './types';
import './styles.css';
import { clsx } from 'clsx';

export function LogoLinks({ align = 'left', columns = 3, ...props }: LinkListsProps) {
  const customProperties = {
    '--footer-links-list-item-align': align,
  } as CSSProperties;

  return (
    <section className={clsx('footer__links-section', `column-${columns}`)} style={customProperties}>
      <LinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.payments}
        type="payment"
        variant="logo"
        title={props.constants.i18n_safe_payment}
        addHref={false}
        navigationLink={props.payments[0]?.url || ''}
        device={props.device}
      />
      <LinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.socialMedia}
        type="social"
        variant="logo"
        title={props.constants.i18n_visit_us}
        addHref={true}
        device={props.device}
      />
      <LinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.shippings}
        type="shipping"
        variant="logo"
        title={props.constants.i18n_fast_delivery}
        addHref={true}
        device={props.device}
      />
      <LinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.secures}
        type="secure"
        variant="logo"
        title={props.constants.i18n_security_guarantee}
        addHref={true}
        device={props.device}
      />
    </section>
  );
}
